export const SET_CONVERSATION = "SET_CONVERSATION";
export const CREATE_CONVERSATION = "CREATE_CONVERSATION";
export const CONVERSATIONS_RECEIVED = "CONVERSATIONS_RECEIVED";
export const SET_PROPERTY_CONVERSATION = "SET_PROPERTY_CONVERSATION";
export const TAGS_RECEIVED = "TAGS_RECEIVED";
export const SET_THREAD_MESSAGES = "SET_THREAD_MESSAGES";


